import { computed, watch } from 'vue'
import { session } from '../session.js'
import { createHistoryState, hasHistoryDraftChanges, historyFilters, historyQueryKey, historyScope } from './historyState.js'

export const historyState = createHistoryState()
watch(() => historyScope(session), (scope) => historyState.setScope(scope), { immediate: true, flush: 'sync' })

export function useHistorySession(flow, { applied, draft, pageNumber, pageSize, searchDraft, options, denied }) {
  let owner = historyState.ticket()
  let displayedKey = ''
  let verified = false
  const query = () => ({ applied: historyFilters(flow, applied), pageNumber: pageNumber.value, pageSize: pageSize.value })
  function capture() {
    if (!verified || denied.value) return
    historyState.savePreferences(flow, owner, { ...query(), draft, searchDraft: searchDraft?.value,
      selectedLabels: Object.fromEntries(Object.entries(options).map(([facet, state]) => [facet, state.selected])) })
  }
  function restore() {
    owner = historyState.ticket()
    verified = true
    const value = historyState.restore(flow, owner)
    if (!value) return null
    Object.assign(applied, value.applied); Object.assign(draft, value.draft)
    pageNumber.value = value.pageNumber; pageSize.value = value.pageSize
    if (searchDraft) searchDraft.value = value.searchDraft
    for (const [facet, selected] of Object.entries(value.selectedLabels)) if (options[facet]) options[facet].selected = selected
    displayedKey = value.page ? historyQueryKey(flow, query()) : ''
    return value
  }
  return {
    query, capture, restore,
    resetOwner: () => { owner = historyState.ticket(); displayedKey = ''; verified = false },
    deny: () => { historyState.clear(); verified = false; displayedKey = '' },
    matchesQuery: () => displayedKey === historyQueryKey(flow, query()),
    saveResult: (descriptor, page) => {
      if (historyState.saveResult(flow, owner, descriptor, page)) {
        displayedKey = historyQueryKey(flow, descriptor); verified = true
      }
    },
    unapplied: computed(() => hasHistoryDraftChanges(flow, draft, applied)),
  }
}
